import React from "react";

export function useResizeDetector<T extends HTMLElement>(
    ref: React.RefObject<T>,
    callback: (width: number, height: number) => void
) {

    const [size, setSize] = React.useState<[number, number] | null>(null);
    React.useLayoutEffect(() => {
        if (size !== null) {
            callback(...size);
        }
    }, [size]);

    React.useLayoutEffect(() => {
        if (!ref.current) {
            return () => {
            }
        }

        const resizeObserver = new ResizeObserver(entries => {
            for (const entry of entries) {
                setSize([entry.target.clientWidth, entry.target.clientHeight]);
            }
        });
        resizeObserver.observe(ref.current);
        return () => {
            resizeObserver.disconnect();
        }
    }, []);

}
